<template>
  <div>
    <!-- NOTE: @click.self は radio button の黒丸・label 以外をクリックされたときの対応 -->
    <div class="radio_btn check-list" @click.self="select(allElementValue)">
      <input
        :id="prefixForLabel + allElementValue"
        v-model.number="selectedId"
        type="radio"
        :value="allElementValue"
        @change="onSelect"
      />
      <label class="radio-label " :for="prefixForLabel + allElementValue">
        すべて
      </label>
    </div>
    <div
      v-for="(element, index) in elements"
      :key="index"
      class="check-list-radio-btn"
      @click.self="select(element.id)"
    >
      <input
        :id="prefixForLabel + element.id"
        v-model.number="selectedId"
        type="radio"
        :value="element.id"
        @change="onSelect"
      />
      <label class="radio-label" :for="prefixForLabel + element.id">
        {{ element.name }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    elements: {
      type: Array,
      required: true
    },
    defaultValue: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    prefixForLabel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedId: 0
    }
  },
  computed: {
    allElementValue() {
      // NOTE: idの最大値 + 1 を取得
      return (
        this.elements.reduce((previousValue, currentValue) =>
          previousValue.id >= currentValue.id ? previousValue : currentValue
        ).id + 1
      )
    }
  },
  mounted() {
    this.selectedId = this.defaultValue
      ? this.defaultValue
      : this.allElementValue
  },
  methods: {
    select(value) {
      if (this.selectedId === value) {
        return
      }
      this.selectedId = value
      this.onSelect()
    },
    onSelect() {
      this.selectedId === this.allElementValue
        ? this.$emit('clicked', null)
        : this.$emit('clicked', this.selectedId)
    },
    isSelected(elementId) {
      return this.selectedId === elementId
    }
  }
}
</script>
